import React from "react";
export default function TickSvg() {return <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="15" height="10"><path d="m6.3 10.592 8.246-8.017-2.092-2.15L6.3 6.408l-3.754-3.65-2.092 2.15L6.3 10.593Z" fillRule="evenodd" fill="currentColor"/></svg>}
